import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { AdminLayout } from '../components/admin/AdminLayout';
import { PublicLayout } from '../components/layouts/PublicLayout';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page').then(module => ({ default: module.HomePage })));
const AboutPage = lazy(() => import('../pages/about/page').then(module => ({ default: module.AboutPage })));
const ServicesPage = lazy(() => import('../pages/services/page').then(module => ({ default: module.ServicesPage })));
const CNCTornaPage = lazy(() => import('../pages/services/cnc-torna/page').then(module => ({ default: module.CNCTornaPage })));
const CNCDikIslemePage = lazy(() => import('../pages/services/cnc-dik-isleme/page').then(module => ({ default: module.CNCDikIslemePage })));
const UniversalTornaFrezePage = lazy(() => import('../pages/services/universal-torna-freze/page').then(module => ({ default: module.UniversalTornaFrezePage })));
const KaynakPage = lazy(() => import('../pages/services/kaynak/page').then(module => ({ default: module.KaynakPage })));
const Printer3DPage = lazy(() => import('../pages/services/3d-printer/page').then(module => ({ default: module.Printer3DPage })));
const QualityPage = lazy(() => import('../pages/quality/page').then(module => ({ default: module.QualityPage })));
const BlogPage = lazy(() => import('../pages/blog/page').then(module => ({ default: module.BlogPage })));
const BlogPostPage = lazy(() => import('../pages/blog/post/page').then(module => ({ default: module.BlogPostPage })));
const ContactPage = lazy(() => import('../pages/contact/page').then(module => ({ default: module.ContactPage })));
const QuotePage = lazy(() => import('../pages/quote/page').then(module => ({ default: module.QuotePage })));
const NotFound = lazy(() => import('../pages/NotFound'));

const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminPages = lazy(() => import('../pages/admin/pages/page'));
const AdminMenus = lazy(() => import('../pages/admin/menus/page'));
const AdminHome = lazy(() => import('../pages/admin/home/page'));
const AdminServices = lazy(() => import('../pages/admin/services/page'));
const AdminBlog = lazy(() => import('../pages/admin/blog/page'));
const AdminMedia = lazy(() => import('../pages/admin/media/page'));
const AdminForms = lazy(() => import('../pages/admin/forms/page'));
const AdminSEO = lazy(() => import('../pages/admin/seo/page'));
const AdminUsers = lazy(() => import('../pages/admin/users/page'));
const AdminSettings = lazy(() => import('../pages/admin/settings/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'hakkimizda',
        element: <AboutPage />,
      },
      {
        path: 'hizmetler',
        element: <ServicesPage />,
      },
      {
        path: 'hizmetler/cnc-torna',
        element: <CNCTornaPage />,
      },
      {
        path: 'hizmetler/cnc-dik-isleme',
        element: <CNCDikIslemePage />,
      },
      {
        path: 'hizmetler/universal-torna-freze',
        element: <UniversalTornaFrezePage />,
      },
      {
        path: 'hizmetler/kaynak',
        element: <KaynakPage />,
      },
      {
        path: 'hizmetler/3d-printer',
        element: <Printer3DPage />,
      },
      {
        path: 'kalite',
        element: <QualityPage />,
      },
      {
        path: 'blog',
        element: <BlogPage />,
      },
      {
        path: 'blog/:slug',
        element: <BlogPostPage />,
      },
      {
        path: 'iletisim',
        element: <ContactPage />,
      },
      {
        path: 'teklif-al',
        element: <QuotePage />,
      },
    ],
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboard />,
      },
      {
        path: 'pages',
        element: <AdminPages />,
      },
      {
        path: 'menus',
        element: <AdminMenus />,
      },
      {
        path: 'home',
        element: <AdminHome />,
      },
      {
        path: 'services',
        element: <AdminServices />,
      },
      {
        path: 'blog',
        element: <AdminBlog />,
      },
      {
        path: 'media',
        element: <AdminMedia />,
      },
      {
        path: 'forms',
        element: <AdminForms />,
      },
      {
        path: 'seo',
        element: <AdminSEO />,
      },
      {
        path: 'users',
        element: <AdminUsers />,
      },
      {
        path: 'settings',
        element: <AdminSettings />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
